import React from "react";
import { FaGithub, FaLinkedin, FaEnvelope, FaAward, FaCode, FaCloud, FaLock, FaDatabase, FaProjectDiagram } from "react-icons/fa";

const About = () => {
  return (
    <section id="about" className="bg-gradient-to-b from-gray-900 to-gray-800 text-white py-20">
      <div className="max-w-7xl mx-auto flex flex-col items-center justify-center px-5 space-y-12">
        {/* Social Handles */}
        <div className="flex gap-4">
          <a
            href="https://github.com/azedin"
            target="_blank"
            rel="noopener noreferrer"
            className="text-3xl p-3 bg-gray-800 hover:bg-orange-500 text-white rounded-full transition duration-300"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.linkedin.com/in/imaliazzeddine/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-3xl p-3 bg-gray-800 hover:bg-blue-500 text-white rounded-full transition duration-300"
          >
            <FaLinkedin />
          </a>
          <a
            href="mailto:imaliazedin@gmail.com"
            className="text-3xl p-3 bg-gray-800 hover:bg-teal-500 text-white rounded-full transition duration-300"
          >
            <FaEnvelope />
          </a>
        </div>

        {/* Title Section */}
        <div className="text-center">
          <h1 className="text-5xl font-bold">About Me</h1>
          <p className="text-xl text-dark-orange mt-4">
            Azzeddine Imali | AI Engineer & IT Project Manager
          </p>
        </div>

        {/* Bio Section */}
        <div className="max-w-4xl mx-auto space-y-6 text-center">
          <p className="text-lg md:text-xl leading-relaxed">
            I am an IT Engineer with over 4 years of diverse experience spanning the public and private sectors. My expertise
            includes <span className="font-semibold text-teal-400">IT infrastructure management</span>, 
            <span className="font-semibold text-orange-400"> AI integration</span>, and 
            <span className="font-semibold text-teal-400"> digital transformation</span>. 
            I specialize in crafting innovative solutions to address real-world challenges while optimizing operational efficiency.
          </p>
          <p className="text-lg md:text-xl leading-relaxed">
            In my role at the <span className="font-semibold">Ministry of Equipment and Water</span>, 
            I oversee critical IT systems, enhance cybersecurity, and actively contribute to national policy development. 
            My private sector experience at ALTEN MAROC further solidified my technical expertise in telecommunications systems and customer solutions.
          </p>
          <p className="text-lg md:text-xl leading-relaxed">
            Equipped with certifications in <span className="font-semibold">Agile Project Management</span>, 
            <span className="font-semibold"> Business Intelligence</span>, and <span className="font-semibold">Scrum</span>, I thrive in fast-paced, collaborative environments.
          </p>
        </div>

        {/* Skills Section */}
        <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          <div className="bg-gray-800 rounded-lg p-6 text-center shadow-lg">
            <FaCode className="text-4xl text-orange-400 mb-3" />
            <h3 className="text-xl font-semibold text-dark-orange">Programming</h3>
            <p>Python, JavaScript, C++, PHP, Java</p>
          </div>
          <div className="bg-gray-800 rounded-lg p-6 text-center shadow-lg">
            <FaDatabase className="text-4xl text-teal-400 mb-3" />
            <h3 className="text-xl font-semibold text-dark-orange">Databases</h3>
            <p>MySQL, PostgreSQL, MongoDB</p>
          </div>
          <div className="bg-gray-800 rounded-lg p-6 text-center shadow-lg">
            <FaCloud className="text-4xl text-blue-400 mb-3" />
            <h3 className="text-xl font-semibold text-dark-orange">Cloud Platforms</h3>
            <p>AWS, Microsoft Azure</p>
          </div>
          <div className="bg-gray-800 rounded-lg p-6 text-center shadow-lg">
            <FaLock className="text-4xl text-orange-400 mb-3" />
            <h3 className="text-xl font-semibold text-dark-orange">Cybersecurity</h3>
            <p>Data Protection, GDPR Compliance</p>
          </div>
          <div className="bg-gray-800 rounded-lg p-6 text-center shadow-lg">
            <FaProjectDiagram className="text-4xl text-teal-400 mb-3" />
            <h3 className="text-xl font-semibold text-dark-orange">Frameworks</h3>
            <p>React, Django, Symfony, Angular</p>
          </div>
          <div className="bg-gray-800 rounded-lg p-6 text-center shadow-lg">
            <FaAward className="text-4xl text-yellow-400 mb-3" />
            <h3 className="text-xl font-semibold text-dark-orange">Certifications</h3>
            <p>Agile, Scrum, BI Foundation</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
